import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
  padding: "space60",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  backgroundColor: "colorBackground",
  textAlign: "center"
};

export const titleStyles: TextStyleProps = {
  fontSize: "fontSize50"
};

export const textStyles: TextStyleProps = {
  marginBottom: "space50",
  marginTop: "space50"
};

/*
 *export const buttonStyle = {
 *   backgroundColor: "#FF5995",
 *   boxSizing: "border-box",
 *   width: "auto",
 *   appearance: "none",
 *   display: "inline-block",
 *   border: "none",
 *   outline: "none",
 *   transition: "background-color 100ms ease-in 0s, box-shadow 100ms ease-in 0s, color 100ms ease-in 0s",
 *   fontWeight: "600",
 *   textDecoration: "none",
 *   position: "relative",
 *   margin: "0px",
 *   cursor: "pointer",
 *   color: "white",
 *   padding: "0.5rem 0.75rem",
 *   borderRadius: "4px",
 *   fontSize: "0.875rem",
 *   lineHeight: "1.25rem"
 *};
 */
